import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { Layout } from '@/components/Layout';
import { Home } from '@/components/home/Home';
import { Login } from '@/components/home/Login';
import { PleaseWait } from '@/components/PleaseWait';
import { useUserState } from '@/hooks/useUserState';
import { UserProvider } from '@/contexts/UserContext';
import { ChooseTarget } from '@/components/logbook/target/ChooseTarget';
import { NotificationProvider } from '@/contexts/NotificationCtx';
import { HandleErrors } from '@/HandleErrors';
import axios from 'axios';
import { LogbookForm } from '@/components/logbook/LogbookForm';
import { DriveOnProvider } from '@/contexts/DriveOnContext';
import { ReportTable } from '@/components/report/ReportTable';
import { MyTasks } from '@/components/logbook/task/MyTasks';

import './App.css';

function App() {
  const logoutApi: string = '/api/logout';
  const loginApi: string = import.meta.env.VITE_LOGIN_URL;

  const [user, setUser] = useUserState(undefined);
  async function logout() {
    frontendLogout();
    await axios.post(logoutApi, { withCredentials: true, withXSRFToken: true });
  }

  function frontendLogout() {
    setUser(null);
  }

  function getErrorMsg() {
    const queryParameters = new URLSearchParams(window.location.search);
    const errorMsg = queryParameters.get('error');
    return errorMsg;
  }

  function RenderLogin() {
    return <Login loginApi={loginApi} msg={getErrorMsg()} />;
  }

  function RenderApp() {
    return (
      <HandleErrors logout={frontendLogout}>
        <UserProvider loggedInUser={user} logout={logout}>
            <DriveOnProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Layout />}>
                    <Route index path="/fooldal" element={<Home />} />
                    <Route path="/menetlevel" element={<LogbookForm withChooseTaskDialog={false} />} />
                    <Route path="/menetlevel/jarmuvalaszto" element={<ChooseTarget />} />
                    <Route path="/menetlevel/feladatvalaszto" element={<LogbookForm withChooseTaskDialog={true} />} />
                    <Route path="/feladataim" element={<MyTasks />} />
                    <Route path="/report" element={<ReportTable />} />
                    <Route path="/" element={<Navigate replace to="/fooldal" />} />
                    <Route path="*" element={<Navigate replace to="/fooldal" />} />
                  </Route>
                </Routes>
              </BrowserRouter>
            </DriveOnProvider>
        </UserProvider>
      </HandleErrors>
    );
  }

  function render() {
    switch (user) {
      case undefined:
        return <PleaseWait />;
      case null:
        return <RenderLogin />;
      default:
        return <RenderApp />;
    }
  }

  return <NotificationProvider>{render()}</NotificationProvider>;
}

export default App;
